const my_offers_tab = {
  my_available_offers: 'My available offers ({{offers}})',
  offer_details: 'Offer details',
  to_access: 'To access',
}


export default my_offers_tab
